App.controller('ResponseResponseListCtrl', ResponseResponseListCtrl);

ResponseResponseListCtrl.$inject = [
    'summary',
    'responses',
    '$route',
    'DataDrivenDialogService',
    'responseFactory',
    'DialogService'
];

function ResponseResponseListCtrl(summary, responses, $route, DataDrivenDialogService, responseFactory, DialogService) {
    var vm = this;

    vm.summary = summary;
    vm.responses = responses;
    vm.filters = [];

    vm.addTypeFilter = addTypeFilter;
    vm.typeFilter = typeFilter;
    vm.setResponseType = setResponseType;
    vm.deleteResponse = deleteResponse;

    vm.code = $route.current.params.code;

    function addTypeFilter(type) {
        var i = $.inArray(type, vm.filters);

        if (i > -1) {
            vm.filters.splice(i, 1);
        } else {
            vm.filters.push(type);
        }
    }

    function typeFilter(response) {
        if (vm.filters.length > 0) {
            if ($.inArray(response.type, vm.filters) < 0)
                return;
        }

        return response;
    }

    function setResponseType(response) {
        /* display the set response type dialog */
        DataDrivenDialogService.show('SetResponseType', response, function() {
            responseFactory.updateResponse(vm.code, response)
        });
    }

    /**
     * Let an admin delete an individual survey response
     *
     * @param response
     */
    function deleteResponse(response) {
        DialogService.confirm('delete this response', null, function(confirmed) {
            if (confirmed) {
                responseFactory.destroyResponse(vm.code, response).then(function() {
                    DialogService.success('The response has been successfully deleted. Page will automatically reload.', null, function() {
                        location.reload();
                    });
                });
            }
        });
    }
}
